import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createBlock(_component_l_map, {
    center: _ctx.mapCenter,
    zoom: 13,
    style: {"height":"80vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_l_tile_layer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboards, (user, index) => {
        return (_openBlock(), _createBlock(_component_l_marker, {
          key: `k-${index}`,
          "lat-lng": [user.latitude, user.longitude],
          icon: _ctx.getIcon(user.plant)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_l_tooltip, {
              ref_for: true,
              ref: "mapTooltip",
              options: { permanent: _ctx.permanentTooltip }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(`${user.plant}`), 1),
                _createElementVNode("div", null, _toDisplayString(`${user.dman} : ${user.dmanName}`), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.dayjs(user.timeStamp).fromNow()), 1)
              ]),
              _: 2
            }, 1032, ["options"])
          ]),
          _: 2
        }, 1032, ["lat-lng", "icon"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["center"]))
}